import Modal from "../../components/Modal";
import PageHeader from "../../components/PageHeader";
import PageActions from "../../components/PageActions";
import Table from "../../components/Table";
import FilterModal from "../../components/FilterModal";

import LojaForm from "./components/LojaForm";

import { lojaFilterFields } from "./constants/filterFields";

import { LojaProvider, useLoja } from "./context/LojaContext";
import { useState } from "react";

import { createTableActions } from "../../utils/tableActions";

const LojaContent = () => {
  const {
    filters,
    lojas,
    isOpen,
    editingItem,
    isLoading,
    openModal,
    closeModal,
    handleFieldChange,
    handleSearch,
    handleClear,
    handleSubmit,
    handleEdit,
    handleDelete,
  } = useLoja();

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const activeFiltersCount = Object.values(filters).filter(
    (value) => value !== null && value !== undefined && value !== ""
  ).length;

  const tableActions = createTableActions(handleEdit, handleDelete);

  const filterFields = lojaFilterFields.map((field) => ({
    ...field,
    value: filters[field.name as keyof typeof filters] || "",
  }));

  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-4 mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <PageHeader
          title="Gerenciar Lojas"
          description="Aqui você pode administrar todas as lojas do sistema"
        />
        <PageActions
          onFilter={() => setIsFilterModalOpen(true)}
          onAdd={() => openModal()}
          addButtonText="Nova Loja"
          activeFiltersCount={activeFiltersCount}
        />
      </div>

      <hr />

      <div className="overflow-x-auto pb-4">
        <div className="min-w-max">
          <Table
            headers={[
              "Nome",
              "Endereço",
              "CNPJ",
              "Telefone",
              "Integração pedidos",
              "Roteirização auto",
              "Raio (km)",
            ]}
            data={lojas.map((loja) => [
              loja.nome,
              loja.endereco,
              loja.cnpj,
              loja.telefone,
              loja.usaIntegracaoPedidos ? "Sim" : "Não",
              loja.roteirizacaoAutomaticaAtiva ? "Sim" : "Não",
              loja.distanciaMaximaCasamentoKm ?? 2,
            ])}
            actions={tableActions}
          />
        </div>
      </div>

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        fields={filterFields}
        onFieldChange={handleFieldChange}
        onSearch={() => {
          handleSearch();
          setIsFilterModalOpen(false);
        }}
        onClear={handleClear}
      />

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={editingItem ? "Editar Loja" : "Nova Loja"}
        description="Complete as abas para configurar dados gerais e o Roteirista automático."
        bodyClassName="flex min-h-0 flex-1 flex-col overflow-hidden p-6"
      >
        {isOpen && (
          <LojaForm
            initialData={editingItem || undefined}
            onSubmit={handleSubmit}
            onCancel={closeModal}
            isLoading={isLoading}
          />
        )}
      </Modal>
    </main>
  );
};

const Loja = () => {
  return (
    <LojaProvider>
      <LojaContent />
    </LojaProvider>
  );
};

export default Loja;
